import { RandomUtils } from '../utils/random-utils';

export enum AddressType {
  // activity = 'Activité', // PRED-2281
  billing = 'Facturation',
  delivery = 'Livraison',
}

export const addressTranslation = (status: AddressType) => {
  switch (status) {
    case AddressType.billing:
      return 'Facturation';
    case AddressType.delivery:
      return 'Livraison';
    default:
      return 'Statut inconnu';
  }
};

export const addressTypeObject = (type: AddressType) => {
  return {
    _id: RandomUtils.generateId(),
    value: type,
    label: addressTranslation(type),
  };
};
